import React, { useEffect, useState } from "react";
import { Form, Input, DatePicker, TimePicker, Select, Button, message } from 'antd';
import { Confirm, Understood } from '../Notification/index.js';
import dayjs from 'dayjs'
import dayTypesArray from './utils/day-type-requests/dayTypes.js';
import statusArray from './utils/day-type-requests/status.js';
import AuthLogic from '../../AuthLogic/index.js';

const { Option } = Select;

const datePickerFormat = { format: 'YYYY-MM-DD' };
const timePickerFormat = { format: 'h:mm a'};

const DayTypeRequestsGeneralForm = ({ contextMenuKey, dayTypeRequestDetails, dayTypesAll, dayTypesDayRule, ...props }) => {
  const [form] = Form.useForm();

  const optionsDayTypes = (dayTypesDayRule && dayTypesDayRule.length > 0) ?
    (
      dayTypesDayRule.map((dayTypeOption) => {
        return { value: dayTypeOption.dayTypeId, label: dayTypeOption.dayTypeName, approvalNeeded: dayTypeOption.approvalNeeded.toString() }
      })
    )
    :
    (
      dayTypesArray.map((dayTypeOption) => {
        return { value: dayTypeOption.id, label: dayTypeOption.name, approvalNeeded: 'false' }
      })
    )
  const optionsStatus = Object.assign([], statusArray.map((item) => ({ value: item.value, label: item.name })))

  const [approvalNeeded, setApprovalNeeded] = useState(true);
  const { getFieldsValue } = form;

  useEffect(() => { // set form values

    form.setFieldsValue({
      dayType: dayTypeRequestDetails.dayTypeId ? dayTypeRequestDetails.dayTypeId : undefined,
      fromDate: dayTypeRequestDetails.fromDate ? dayjs(dayTypeRequestDetails.fromDate) : null,
      toDate: dayTypeRequestDetails.toDate ? dayjs(dayTypeRequestDetails.toDate) : null,
      fromTime: dayTypeRequestDetails.fromTime ? dayjs(dayTypeRequestDetails.fromTime) : null,
      toTime: dayTypeRequestDetails.toTime ? dayjs(dayTypeRequestDetails.toTime) : null,
      status: dayTypeRequestDetails.status ? dayTypeRequestDetails.status : 'U',
      myComment: dayTypeRequestDetails.myComment,
      statusComment: dayTypeRequestDetails.statusComment
    });
  }, [dayTypeRequestDetails, dayTypesDayRule]);

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 2,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const validateDayType = (form) => {
    const dayType = form.getFieldValue('dayType');
    if (!dayType) {
      let dayTypeErrors = [];
      dayTypeErrors.push('Please input day type!')

      form.setFields([{
        name: 'dayType',
        value: dayType,
        errors: dayTypeErrors
      }]);
    }
  }

  const validateDates = (form) => {

    let fromDate = form.getFieldValue('fromDate') ? dayjs(form.getFieldValue('fromDate')).startOf('day') : null;
    let toDate = form.getFieldValue('toDate') ? dayjs(form.getFieldValue('toDate')).startOf('day') : null;

    console.log(fromDate)
    console.log(toDate)

    let fromDateErrors = [];
    if (!fromDate) {
      fromDateErrors.push('Please input start date!');
    }
    if (fromDate && toDate && toDate.isBefore(fromDate)) {
      fromDateErrors.push('Start date cannot occur after end date!');
    }
    form.setFields([{
      name: 'fromDate',
      errors: fromDateErrors
    }]);


    if (toDate == null) {
      toDate = fromDate;
    }

    let toDateErrors = [];
    if (!toDate) {
      toDateErrors.push('Please input end date!');
    }
    if (toDate && fromDate && fromDate.isAfter(toDate)) {
      toDateErrors.push('End date cannot occur before start date!');
    }
    form.setFields([{
      name: 'toDate',
      errors: toDateErrors
    }]);


  }


  const validateTime = (form) => {
    const fromTime = form.getFieldValue('fromTime') ? dayjs(form.getFieldValue('fromTime')) : null;
    const toTime = form.getFieldValue('toTime') ? dayjs(form.getFieldValue('toTime')) : null;
    let fromTimeErrors = [];
    if (toTime && fromTime && toTime.isBefore(fromTime)) {
      fromTimeErrors.push('Start time cannot occur after end time!');
    }
    if (!fromTime && toTime) {
      fromTimeErrors.push('Please choose a start time if you have an end time!');
    }

    form.setFields([{
      name: 'fromTime',
      errors: fromTimeErrors
    }]);

    let toTimeErrors = [];
    if (fromTime && toTime && fromTime.isAfter(toTime)) {
      toTimeErrors.push('End time cannot occur before start time!');
    }
    if (!toTime && fromTime) {
      toTimeErrors.push('Please choose an end time if you have a start time!');
    }

    form.setFields([{
      name: 'toTime',
      errors: toTimeErrors
    }]);
  }

  const validateComments = (form) => {
    let statusComment = form.getFieldValue('statusComment') || '';
    let myComment = form.getFieldValue('myComment') || '';


    let statusCommentErrors = [];
    if (statusComment && statusComment.length > 250) {
      statusCommentErrors.push('Maximum length is 250 characters!')
      statusComment = statusComment.substring(0, 250)
    }

    form.setFields([{
      name: 'statusComment',
      value: statusCommentErrors ? statusComment : statusComment.replace(/[^a-zA-Z0-9,:;\-.!@?#%|/$()& \n]/g, ''),
      errors: statusCommentErrors
    }]);


    let myCommentErrors = [];
    if (myComment && myComment.length > 250) {
      myCommentErrors.push('Maximum length is 250 characters!')
      myComment = myComment.substring(0, 250)
    }

    form.setFields([{
      name: 'myComment',
      value: myCommentErrors ? myComment : myComment.replace(/[^a-zA-Z0-9,:;\-.!@?#%|/$()& \n]/g, ''),
      errors: myCommentErrors
    }]);

  }

  const validateForm = () => { // validates the whole form

    validateDayType(form);
    validateDates(form);
    validateTime(form);
    validateComments(form);
  }

  const validateHasHolidays = async (formValues) => {

    let dayTypeHasHolidays = await props.checkIfHasHolidaySchedule(formValues);

    if (dayTypeHasHolidays) {
      props.createDayTypeRequest(formValues);
    } else {
      Confirm('key', { title: 'Validate Date', content: 'STORM was not able to validate if the selected date(s) are holiday(s). Do you want to continue?' }, (key, value) => {
        if (value) {
          props.createDayTypeRequest(formValues);
        }
      });
    }
  }



  const handleCreate = async () => {
    validateForm();
    const values = form.getFieldsValue()
    const listErrors = form.getFieldsError()
    const hasErrors = listErrors.some(({ errors }) => errors.length > 0);
    if (hasErrors) return ;


    let formValues = getFieldsValue()
    let dateRangeInfo = await props.checkIfTourInDateRange(formValues);
    let foundDayType;
    var rules = props.getDayTypesByDayRule();
    var all = props.getDayTypesAll();

    if (rules && rules.length && rules.length > 0) {
      foundDayType = rules.find(dayType => dayType.dayTypeId === formValues.dayType);
    } else {
      foundDayType = all.find(dayType => dayType.dayTypeId === formValues.dayType);
    }

    if (!(dateRangeInfo && (dateRangeInfo.tourCounter > 0 || dateRangeInfo.jeCounter > 0))) {
      await validateHasHolidays(formValues);
      return;
    }

    if (dateRangeInfo.tourApproved > 0) {
      const message = 'There are approved tours in this dates range.\nCannot fulfill this request. Please contact your manager if you have any questions'
      Understood('key', { title: 'Tours in date range', content: message }, (key, value) => { });
      return;
    }
    if (dateRangeInfo.jeApproved > 0) {
      const message = 'There are tours with approved assigments in this dates range.\nCannot fulfill this request. Please contact your manager if you have any questions'
      Understood('key', { title: 'Tours in date range', content: message }, (key, value) => { });
      return;
    }

    if (foundDayType.allowTourScheduling) {
      await props.createDayTypeRequest(formValues);
      return;
    }

    if (formValues.status != "A") {
      await validateHasHolidays(formValues);
      return;
    }

    if (props.user.securityLevels.allowDeletingTour == 2) {/*No*/
      const message = 'There are tours/assignments in the date range chosen.\nCannot fulfill this request. Please contact your manager if you have any questions'
      Understood('key', { title: 'Tours in date range', content: message }, (key, value) => { });

    } else {
      const message = 'There are tours/assignments in the date range chosen.\nDo you want to proceed with this request and delete the tours/assignments?'
      Confirm('key', { title: 'Tours in date range', content: message }, async (key, value) => {
        if (value) {
          await validateHasHolidays(formValues);
        }
      });

    }

  }

  const handleUpdate = async () => {
    validateForm()

    if (Object.values(errors).length === 0) {
      let formValues = getFieldsValue()

      let dateRangeInfo = await props.checkIfTourInDateRange(formValues);
      if (dateRangeInfo && (dateRangeInfo.tourCounter > 0 || dateRangeInfo.jeCounter > 0) && formValues.status === "A") {
        const message = 'There are tours/assignments in the date range chosen. Do you want to proceed with this request and delete the tours/assignments?'
        Confirm('key', { title: 'Tours in date range', content: message }, (key, value) => {
          if (value) {
            console.log('Success! Received values of form: ', formValues)
            props.updateDayTypeRequest(formValues, dayTypeRequestDetails.dayTypeRequestId);
          }
        });
      } else {
        console.log('Success! Received values of form: ', formValues);
        props.updateDayTypeRequest(formValues, dayTypeRequestDetails.dayTypeRequestId);
      }
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  }

    const handleKeyPress = (e) => {
    e.preventDefault();
    let inputField = e.target;
    const start = inputField.selectionStart;
    const end = inputField.selectionEnd;
    const currentValue = inputField.value;
    const sanitizedText = e.data.replace(/[^a-zA-Z0-9,:;\-.!@?#%|\/$()&\s\n]/g, "");
    const newValue = currentValue.slice(0, start) + sanitizedText + currentValue.slice(end);
    switch (e.currentTarget.id) {
      case "myComment":
        form.setFieldsValue({ myComment: newValue });
        break;
      case "statusComment":
        form.setFieldsValue({ statusComment: newValue });
        break;
    }
  };

  const handleDelete = () => {
    if (dayTypeRequestDetails.dayTypeRequestId) {
      props.deleteDayTypeRequest(dayTypeRequestDetails.dayTypeRequestId);
    } else {
      message.config({
        top: 150,
        duration: 5,
        maxCount: 5,
      });
      message.error('Could not perfom delete on this request');
    }
  }

  const formItemDisabledOnEdit = () => {
    //review when update enabled
    //contextMenuKey ? !AuthLogic.addDayTypeRequest(props.user) : !AuthLogic.editDayTypeRequest(props.user)

    return !contextMenuKey;
  }

  const formCommentReadOnly = () => {
    return props.user.securityLevels.remark != 3/*Edit*/
  }
  const formCommentStatusReadOnly = () => {
    return props.user.securityLevels.statusRemark != 3
  }

  const formCommentVisible = () => {
    return props.user.securityLevels.remark != 1/*None*/
  }
  const formCommentStatusVisible = () => {
    return props.user.securityLevels.statusRemark != 1
  }

  const handleApprovalNeeded = (e, t) => {
    if (t) {
      let approval = (t.approvalNeeded === 'true' || t.approvalNeeded === true);
      setApprovalNeeded(approval);
      if (!approval) {
        form.setFieldsValue({ status: { value: "A" } });
      } else {
        form.setFieldsValue({ status: { value: "U" } });
      }
    }
    props.handleDayTypeChange(e, validateForm);
  }

  const controlButtonDisabled = {
    backgroundColor: '#f5f5f5',
    color: 'rgb(143, 143, 143)',
    cursor: 'not-allowed',
    opacity: 1,
    resize: "none",
  }
  const controlButtonEnabled = {
    resize: "none"
  }


  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };



  return (
    <Form form={form} layout='horizontal'
      {...formItemLayout}
    >
      <Form.Item
        label="Day Type"
        name="dayType"
        rules={[{
          required: true, message: 'Please input a Day Type!',
        }]}
      >
        <Select
          onChange={(e, t) => { handleApprovalNeeded(e, t); }}
          allowClear={true}
          disabled={(formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType) ? true : false}
          options={optionsDayTypes}
        >
        </Select>
      </Form.Item>

      <Form.Item
        label="From Date"
        name="fromDate"
        rules={[{
          required: true,
          message: 'Please input start date!'
        }]}
      >
        <DatePicker
          //showTime={{ format: datePickerFormat, use12Hours: true }}
          onChange={(e) => props.handleToDateChange(e, validateForm)}
          allowClear={true}
          format={datePickerFormat}
          disabled={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
        />
      </Form.Item>

      <Form.Item
        label="To Date"
        name="toDate"
        rules={[{
          required: true,
          message: 'Please input end date!'
        }]}
      >
        <DatePicker
          //showTime={{ format: datePickerFormat, use12Hours: true }}
          onChange={(e) => props.handleToDateChange(e, validateForm)}
          allowClear={true}
          format={datePickerFormat}
          disabled={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
        />
      </Form.Item>

      <Form.Item label="From Time" name="fromTime">
        <TimePicker
          onChange={(e) => props.handleFromTimeChange(e, validateForm)}
          allowClear={false}
          format={timePickerFormat}

          disabled={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
          use12Hours={true}
          minuteStep={15}
          showNow={false}
        />
      </Form.Item>

      <Form.Item label="To Time" name="toTime">
        <TimePicker
          onChange={(e) => props.handleToTimeChange(e, validateForm)}
          allowClear={false}
          format={timePickerFormat}
          disabled={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
          use12Hours={true}
          minuteStep={15}
          showNow={false}
        />
      </Form.Item>

      {AuthLogic.viewStatus(props.user) &&
        <Form.Item label="Status" name="status"
          rules={[{
            required: true, message: 'Please input a status!',
          }]}>
          <Select
            onChange={(e) => props.handleStatusChange(e, validateForm)}
            {...(((!approvalNeeded || !AuthLogic.editStatus(props.user)) || formItemDisabledOnEdit()) ? { disabled: true } : {})}
            options={optionsStatus}
          >

          </Select>
        </Form.Item>
      }

      {formCommentVisible() &&
        <Form.Item
          label="My Comment"
          name="myComment"
        >
          <Input.TextArea
            onChange={(e) => props.handleMyCommentChange(e, validateForm)}
            size={'large'}
            placeholder={(formItemDisabledOnEdit() || formCommentReadOnly()) ? '' : 'Enter text here.'}
            readOnly={formItemDisabledOnEdit() || formCommentReadOnly()}
            style={(formItemDisabledOnEdit() || formCommentReadOnly()) ? controlButtonDisabled : controlButtonEnabled}
            rows={4}
            onBeforeInput={handleKeyPress}
          />
        </Form.Item>
      }

      {formCommentStatusVisible() &&
        <Form.Item
          label="Status Comment"
          name="statusComment"
        >

          <Input.TextArea

            onChange={(e) => props.handleStatusCommentChange(e, validateForm)}
            size={'large'}
            placeholder={(formItemDisabledOnEdit() || formCommentStatusReadOnly()) ? '' : 'Enter text here.'}
            readOnly={formItemDisabledOnEdit() || formCommentStatusReadOnly()}
            style={(formItemDisabledOnEdit() || formCommentStatusReadOnly()) ? controlButtonDisabled : controlButtonEnabled}
            rows={4}
            onBeforeInput={handleKeyPress}
          />

        </Form.Item>
      }

      {contextMenuKey
        ?
        <React.Fragment>
          {AuthLogic.addDayTypeRequest(props.user) && (
            <Form.Item
              style={{ marginTop: 20 }}
            >
              <Button type="primary" size={'large'} onClick={handleCreate}>
                Create
              </Button>
            </Form.Item>
          )}
        </React.Fragment>
        :
        <React.Fragment>
          <Form.Item
            style={{ marginTop: 20 }}
          >
            {/* {AuthLogic.editDayTypeRequest(props.user) && (
              <Button type="primary" size={'large'} onClick={handleUpdate}>
                Update
              </Button>
            )} */}

            {/* {AuthLogic.removeDayTypeRequest(props.user) && dayTypeRequestDetails.status !== 'A' && (
              <Button type="danger" size={'large'} onClick={handleDelete}>
                Delete
              </Button>
            )} */}
          </Form.Item>
        </React.Fragment>
      }
    </Form>
  );
}

export default DayTypeRequestsGeneralForm;
